import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FourthStepService } from './fourth-step.service';
import { CalculationResource } from '../model/calculationResource';

type OutputJson = {
  image?: string | undefined;
  note?: string | undefined;
};

@Component({
  selector: 'app-fourth-step',
  templateUrl: './fourth-step.component.html',
  styleUrls: ['./fourth-step.component.scss']
})
export class FourthStepComponent implements OnInit {

  @Output() finish = new EventEmitter<Boolean>();
  @Input() calculation: CalculationResource | undefined;

  customerForm: FormGroup;
  selectedFile: File | null = null;

  constructor(
    public _service: FourthStepService,
    private _formBuilder: FormBuilder,
  ) {

    this.customerForm = this._formBuilder.group({
      note: [''],
    });

    this.customerForm.valueChanges.subscribe((formData) => {
      this.saveToLocalStorage();
    });
  }

  ngOnInit(): void {
    const savedFormData = localStorage.getItem('noteForm');

    if (savedFormData) {
      const parsedData = JSON.parse(savedFormData);
      this.customerForm.patchValue(parsedData);
    }
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  onSubmit(): void{

    const formValues = this.customerForm.getRawValue();

    let output: OutputJson = {
      image: undefined,
      note: formValues.note,
    };

    if (this.selectedFile) {
      const reader = new FileReader();
      reader.onload = () => {
        output.image = reader.result as string;

        this._service.assignExtras(String(this.calculation?.id) ,output).subscribe(success => {
          this.finish.emit(true);
        }, error => {

        });
      };

      reader.readAsDataURL(this.selectedFile);
    }else{

      this._service.assignExtras(String(this.calculation?.id) ,output).subscribe(data => {
        this.finish.emit(true);
      });

    }
  }

  saveToLocalStorage(): void {
    const formData = this.customerForm.value;
    localStorage.setItem('noteForm', JSON.stringify(formData));
  }

}
